export function scrollToAnimated(selector: string, offsetY = 80, container?: Element) {
    const target = document.querySelector(selector);
    scrollToElAnimated(target, offsetY, container);
}

export function scrollToElAnimated(element: Element, offsetY = 80, container?: Element) {
    if (!element) {
        return;
    }

    if (container) {
        const containerRect = container.getBoundingClientRect();
        const targetRect = element.getBoundingClientRect();
        const top = targetRect.top - containerRect.top + container.scrollTop - offsetY;

        container.scrollTo({ top, behavior: "smooth" });
    } else {
        window.scroll({ top: window.scrollY + element.getBoundingClientRect().y - offsetY, behavior: "smooth" });
    }
}

export function scrollToBottomAnimated(selector: string) {
    const target = document.querySelector<HTMLElement>(selector);

    if (target) {
        window.scroll({
            top: target.getBoundingClientRect().top + target.offsetHeight - 80,
            behavior: "smooth",
        });
    }
}

function getScrollSelectorFromHash(urlWithHash: string) {
    const hash = /.*#scroll-(?<hash>.*)/.exec(urlWithHash).groups?.hash;
    if (!hash) {
        return;
    }
    return `#${hash}`;
}

export function useScrollTo() {
    document.querySelectorAll(".scroll-top").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: "smooth" });
        });
    });

    document.querySelectorAll(".scroll-to").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            const targetSelector = element.getAttribute("href");
            scrollToAnimated(targetSelector);
        });
    });

    document.querySelectorAll(".scroll-to-bottom").forEach((element) => {
        element.addEventListener("click", (e) => {
            e.preventDefault();
            const targetSelector = element.getAttribute("href");
            scrollToBottomAnimated(targetSelector);
        });
    });

    // scroll on page load
    if (location.hash?.indexOf("#scroll-") >= 0) {
        const selector = getScrollSelectorFromHash(location.hash);

        scrollToAnimated(selector, -90);
        // sometimes it jumps back to page start
        setTimeout(() => {
            scrollToAnimated(selector, -90);
        }, 100);
    }

    document.querySelectorAll('a[href*="#scroll-"]').forEach((element) => {
        element.addEventListener("click", () => {
            const selector = getScrollSelectorFromHash(element.getAttribute("href"));
            scrollToAnimated(selector);
        });
    });
}
